import { useEffect, useState } from 'react';
import styles from './VoltaraoTopo.module.css';

const VoltaraoTopo = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        setIsVisible(window.scrollY > 300);
    };

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <button
            className={`${styles.btnVoltaraoTopo} ${isVisible ? styles.show : ''}`}
            onClick={handleScrollToTop}
            aria-label="Voltar ao topo da página"
            title="Voltar ao topo"
        >
            <svg
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"                
                focusable="false"
            >
                <path d="M0.28125 11.2812C0.046875 11.0938 0.046875 10.7188 0.28125 10.4844L10.0781 0.6875C10.3125 0.453125 10.6406 0.453125 10.875 0.6875L20.6719 10.4844C20.9062 10.7188 20.9062 11.0938 20.6719 11.2812L19.7812 12.2188C19.5469 12.4531 19.1719 12.4531 18.9844 12.2188L11.7188 4.95312V20.9375C11.7188 21.2656 11.4375 21.5 11.1562 21.5H9.84375C9.51562 21.5 9.28125 21.2656 9.28125 20.9375V4.95312L1.96875 12.2188C1.78125 12.4531 1.40625 12.4531 1.17188 12.2188L0.28125 11.2812Z" fill="#1C5DB1" />
            </svg>
        </button>
    );
};

export default VoltaraoTopo;